import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { LanguageSelector } from '../LanguageSelector';

interface AppShellProps {
  activePage: string;
  onNavigate: (page: string) => void;
  userName: string;
  onLogout: () => void;
  children: ReactNode;
}

export function AppShell({ activePage, onNavigate, userName, onLogout, children }: AppShellProps) {
  return (
    <div className="app-shell">
      <Sidebar
        activePage={activePage}
        onNavigate={onNavigate}
        userName={userName}
        onLogout={onLogout}
      />
      <main className="app-main">
        <div className="app-main-topbar">
          <LanguageSelector compact />
        </div>
        {children}
      </main>
    </div>
  );
}
